

export default function errorDescription(message: any = '') {
  let errorClass = 'emf-text-yellow-600';
  if (!message) {
    errorClass = 'emf-text-red-400';
    message = 'Sorry! An error occurred while loading the data.'
  }
  return <code className={`emf-min-h-[240px] emf-float-left emf-relative ${errorClass}`}>
    {(typeof message === 'string' || message instanceof String) && message}
    {(typeof message !== 'string') && message.message}
  </code>;
}